import * as React from "react";
const SvgCrossInCircle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 37, height: 36, viewBox: "0 0 37 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18.4988 33C26.783 33 33.4988 26.2843 33.4988 18C33.4988 9.71573 26.783 3 18.4988 3C10.2145 3 3.49878 9.71573 3.49878 18C3.49878 26.2843 10.2145 33 18.4988 33Z", stroke: "#F93232", style: {
  stroke: "#F93232",
  stroke: "color(display-p3 0.9750 0.1950 0.1950)",
  strokeOpacity: 1
}, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M23 13.5L14 22.5", stroke: "#F93232", style: {
  stroke: "#F93232",
  stroke: "color(display-p3 0.9750 0.1950 0.1950)",
  strokeOpacity: 1
}, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M14 13.5L23 22.5", stroke: "#F93232", style: {
  stroke: "#F93232",
  stroke: "color(display-p3 0.9750 0.1950 0.1950)",
  strokeOpacity: 1
}, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgCrossInCircle;
